module.exports = __webpack_public_path__ + "media/packs/images/fact_icons-28f32f966fef35b2886037cb8f80dde9.png";